module.exports = __webpack_public_path__ + "static/Resume-8deff284e89cfbc00cb5f51bff354710.pdf";